export default __webpack_public_path__ + "static/result_back-56540a94f82b0a225c27d9b9734236b9.webp";